angular.module('festzelt-os.modules.navigation', []);

require('./components');

require('./helpers/nav-helper');



// WEBPACK FOOTER //
// ./src/app/modules/navigation/module.js